import './ArrowRight.scss'

function ArrowRight() {
  return <span className='arrow-right' />
}

export default ArrowRight
